import { Badge, Box, Container, Heading, HStack, Icon, SimpleGrid, Text, VStack } from "@chakra-ui/react";
import { FROST, Pill, Reveal, Section, TEAL, TEAL_DARK, TEAL_LIGHT } from "./utils";
import { reasons, solutionCards } from "./data";
import { FaMeh } from "react-icons/fa";

const Solution = () => (
  <Box
    as="section"
    id="solution"
    py={{ base: 16, md: 24 }}
    px={{ base: 5, md: 8 }}
    bgGradient={`linear(155deg, ${TEAL_DARK} 0%, #013545 100%)`}
    overflow="hidden"
    position="relative"
  >
    <Box
      position="absolute"
      top="-60px"
      right="-60px"
      w="280px"
      h="280px"
      borderRadius="50%"
      bg={`${TEAL}28`}
      pointerEvents="none"
    />
    <Box
      position="absolute"
      bottom="-50px"
      left="-50px"
      w="180px"
      h="180px"
      borderRadius="50%"
      bg={`${TEAL_LIGHT}18`}
      pointerEvents="none"
    />

    <Container maxW="6xl" position="relative">
      <VStack gap={10}>
        <Reveal>
          <VStack gap={3} textAlign="center" maxW="600px" mx="auto">
            <Badge
              bg={`${TEAL_LIGHT}28`}
              color={TEAL_LIGHT}
              borderRadius="full"
              px={3}
              py={1}
              fontSize="xs"
              fontWeight={700}
              letterSpacing="wider"
              textTransform="uppercase"
            >
              A Wobble megoldás
            </Badge>
            <Heading
              fontSize={{ base: "xl", md: "2xl" }}
              color="white"
              letterSpacing="-0.02em"
            >
              Egy link. Az ügyfelek maguk foglalnak.
            </Heading>
            <Text color="whiteAlpha.700" lineHeight={1.7} fontWeight={300}>
              Személyes foglalóoldalt kapsz, ami 0–24-ben nyitva tart. Beállítod
              az elérhetőségedet egyszer, megosztod a linket – és a naptárad
              magától megtelik.
            </Text>
          </VStack>
        </Reveal>

        <SimpleGrid columns={{ base: 1, sm: 2, lg: 3 }} gap={4} w="full">
          {solutionCards.map((c, i) => (
            <Reveal key={i} delay={i * 0.07}>
              <HStack
                align="start"
                gap={4}
                p={5}
                bg="whiteAlpha.100"
                borderRadius="xl"
                border="1px solid whiteAlpha.200"
                _hover={{
                  bg: "whiteAlpha.200",
                  borderColor: `${TEAL_LIGHT}55`,
                }}
                transition="all 0.22s"
                h="full"
              >
                <Box
                  w={10}
                  h={10}
                  bg="whiteAlpha.100"
                  borderRadius="lg"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  color={TEAL_LIGHT}
                  flexShrink={0}
                >
                  <Icon as={c.icon} boxSize={4} />
                </Box>
                <Box>
                  <Text fontWeight={700} fontSize="sm" color="white" mb={1}>
                    {c.title}
                  </Text>
                  <Text fontSize="xs" color="whiteAlpha.700" lineHeight={1.65}>
                    {c.body}
                  </Text>
                </Box>
              </HStack>
            </Reveal>
          ))}
        </SimpleGrid>
      </VStack>
    </Container>
  </Box>
);

export default Solution